module.exports = __webpack_public_path__ + "img/skirts.cad6acb1.svg";